import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './index.css';
import './assets/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import DAppProvider
// import { DAppProvider } from "@usedapp/core";
import {store} from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    {/* <DAppProvider config={{}}> */}
      <Provider store={store}>
        <App />
      </Provider>
    {/* </DAppProvider> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
